import { Avatar, Button, Col, List, Row, Space, Typography } from 'antd';
import { notificationsAPI } from 'api/notifications';
import EditIssueModal from 'components/issue/edit-issue-modal';
import moment from 'moment';
import { useState } from 'react';
import { useInfiniteQuery } from 'react-query';
import { NOTIFICATION_REF_TYPE } from 'utils/enum';
import { QUERY_KEY } from 'utils/query-key.enum';

interface LoadMoreProps {
  show: boolean;
  onLoadMore: () => void;
}

const LoadMoreButton = ({ show, onLoadMore }: LoadMoreProps) => {
  return show ? (
    <div style={{ textAlign: 'center' }}>
      <Button type="text" onClick={onLoadMore}>
        Xem thêm
      </Button>
    </div>
  ) : null;
};

interface Props {
  onClickItem: (id: number) => void;
  setShowNotification: React.Dispatch<React.SetStateAction<boolean>>;
}

export const NotificationList = ({
  onClickItem,
  setShowNotification,
}: Props) => {
  const [selectedIssue, setSelectedIssue] = useState<string>();

  const { data, isFetching, fetchNextPage, hasNextPage } = useInfiniteQuery(
    [QUERY_KEY.GET_NOTIFICATION_LIST],
    ({ pageParam }) =>
      notificationsAPI.findAllV2({
        limit: 50,
        ...(pageParam && { cursor: pageParam }),
      }),
    {
      getNextPageParam: (lastPage) => lastPage.nextCursor ?? undefined,
    },
  );

  const rows = data?.pages?.flatMap((e) => e.rows) ?? [];

  const onLoadMoreHandler = () => {
    fetchNextPage();
  };

  return (
    <>
      <List
        loading={isFetching}
        dataSource={rows}
        loadMore={
          <LoadMoreButton show={!!hasNextPage} onLoadMore={onLoadMoreHandler} />
        }
        renderItem={(notification) => (
          <List.Item>
            <List.Item.Meta
              title={
                <>
                  <Typography.Link
                    style={{ opacity: notification.isReaded ? 0.7 : 1 }}
                    onClick={() => {
                      if (!notification.isReaded) {
                        notification.isReaded = true;
                        return onClickItem(notification.id);
                      }

                      if (notification.refType && notification.refId) {
                        switch (notification.refType) {
                          case NOTIFICATION_REF_TYPE.ISSUE:
                            setShowNotification(false);
                            setSelectedIssue(notification.refId);
                            break;
                          default:
                            break;
                        }
                      }
                    }}
                  >
                    {notification.title}
                  </Typography.Link>
                  {!notification.isReaded && (
                    <Typography.Text
                      style={{ color: '#007fff', float: 'right' }}
                    >
                      •
                    </Typography.Text>
                  )}
                </>
              }
              description={
                <>
                  <Typography.Paragraph type="secondary" style={{ margin: 0 }}>
                    {notification.content}
                  </Typography.Paragraph>
                  <Row justify="space-between" gutter={4}>
                    <Col>
                      <Space>
                        <Avatar
                          size={20}
                          src={notification.createdByUser.avatar}
                        />
                        <Typography.Paragraph style={{ margin: 0 }}>
                          {notification.createdByUser.fullName}
                        </Typography.Paragraph>
                      </Space>
                    </Col>
                    <Col>
                      <Typography.Paragraph
                        type="secondary"
                        style={{ margin: 0, fontSize: 12 }}
                      >
                        {moment(notification.createdAt).format(
                          'HH:mm DD/MM/YYYY',
                        )}
                      </Typography.Paragraph>
                    </Col>
                  </Row>
                </>
              }
            />
          </List.Item>
        )}
      />
      {selectedIssue && (
        <EditIssueModal
          id={selectedIssue}
          onCancel={() => setSelectedIssue(undefined)}
          onSubmit={() => setSelectedIssue(undefined)}
        />
      )}
    </>
  );
};
